import { DataSourceItemObject } from "antd/lib/auto-complete";
import { config, IJsonRpcResponse } from "./api";

export interface ICompany {
  companyName: string,
  companyType: string,
  customerID: number | null
  companyProfileID: number,
  isActive: boolean,
  terminationRequestID: number | null
}

interface IGetCompaniesResponse extends IJsonRpcResponse {
  result: {
    companies: ICompany[]
  }
}

// Customer types is a dataSourceItemObject because the object
// we ultimately pass the data to will be looking for that format
interface IGetCustomerTypesResponse extends IJsonRpcResponse {
  result: {
    customerTypes: DataSourceItemObject[]
  }
}

/**
 * Gets all active companies, or a single company if specified.
 *
 * @param authToken the JWT
 * @param companyID companyID to request a single company only
 */
export const getCompanies = async (authToken: string, companyID?: number) => {
  const params = {
    companyID
  };
  const res = await fetch(`${config.url}/getCompanies`, {
    body: JSON.stringify(params),
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + authToken,
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  const body: IGetCompaniesResponse = await res.json();
  return body.result.companies;
};

export const getCustomerTypes = async (authToken: string) => {
  const res = await fetch(`${config.url}/getCustomerTypes`, {
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + authToken,
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  const body: IGetCustomerTypesResponse = await res.json();
  return body.result.customerTypes;
};
